import { Toast } from "flowbite-react";
import {
  HiCheckCircle,
  HiExclamationCircle,
  HiInformationCircle,
} from "react-icons/hi";
import { NOTIFICATION_TYPES } from "../../utils";

const getNotificationIcon = (type) => {
  switch (type) {
    case NOTIFICATION_TYPES.success:
      return <HiCheckCircle className="h-8 w-8 text-green-500" />;
    case NOTIFICATION_TYPES.error:
      return <HiExclamationCircle className="h-8 w-8 text-red-500" />;
    case NOTIFICATION_TYPES.info:
      return <HiInformationCircle className="h-8 w-8 text-orange-500" />;
    default:
      return <HiInformationCircle className="h-8 w-8 text-orange-500" />;
  }
};

export const Notification = ({
  content,
  type = NOTIFICATION_TYPES.info,
  onClear,
}) => (
  <Toast className="mb-4">
    {getNotificationIcon(type)}
    <div className="ml-3 text-sm font-normal">{content}</div>
    <Toast.Toggle onClick={onClear} />
  </Toast>
);
